<div class="dialog-content-min">
    <form [formGroup]="EntitytypeForm">
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="companytype">Entity Type</label>
                                <label for="pagemodal" class="required-label">
                    <span style="color: rgb(60, 137, 246);font-size:9px !important;">(Max 50 chars)</span><span class="required-label">*</span>
                </label>
                <input type="text" class="form-control" id="companytype" inputId="companytype"
                    placeholder="Enter Entity Type" name="companytype" formControlName="companytype" required>
                <span style="color:red" class="errormessage"
                    *ngIf="EntitytypeForm.get('companytype').invalid && (EntitytypeForm.get('companytype').dirty || EntitytypeForm.get('companytype').touched)">
                    {{getErrorMessage(EntitytypeForm ,validation_message,'companytype')}}
                </span>
            </div>
        </div>
    </form>
</div>
<div class="custom-dialog-footer">
    <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
    <p-button class="m-1" label="{{saveTitle}}" styleClass="customesave" (click)="addEntitytype()"></p-button>
</div>